/* eslint-disable semi */
import ja from './locales/ja';
export default {
  ja
};



// WEBPACK FOOTER //
// ./src/lang/index.js